import { get, isEmpty, pick } from 'lodash/fp'
import format from 'date-fns/format'

export default {
  isFetching: (state) => state.isFetching,
  firstName: (state, getters, rootState, rootGetters) =>
    state.firstName || rootGetters['member/firstName'],
  lastName: (state) => state.lastName,
  birthday: (state) => state.birthday,
  guardian: (state) => state.guardian,
  guardianBirthday: (state) => state.guardian.dob,
  registrationAutofillPhone: (state) => {
    return {
      number: state.phone1.value,
      type: state.phone1.type,
    }
  },
  registrationPrimarySms: (state) => {
    const primarySms = state.primarySmsPhone
    return primarySms
      ? {
          number: primarySms.contactNumber,
          type: primarySms.contactNumberCd,
        }
      : {}
  },
  registrationPrimaryVoice: (state) => {
    // NOTE: similar to `registrationAutofillPhone`, but that getter might be going away and this has a fallback value
    const primaryNumber = state.phone1
    return primaryNumber
      ? {
          number: primaryNumber.value,
          type: primaryNumber.type,
        }
      : {}
  },
  registrationEmail: (state) => {
    return state.email
  },
  registrationAddress: (state) => {
    return {
      primary: true,
      streetAddr1: state.street1,
      streetAddr2: state.street2,
      city: state.city,
      state: state.state,
      zip: state.zipCode,
    }
  },
  verifiedRegistrationJwt: (state) => {
    return state.verifiedRegistrationJwt
  },
  registrationInfo: (state) => {
    return {
      clientMemberId: state.memberNumber,
      lastName: state.lastName,
      firstName: state.firstName,
      dob: state.birthday && format(state.birthday, 'yyyy-MM-dd'),
      password: state.password,
      communicationPreferences: state.communicationPreferences,
      smsOptIn: state.smsOptIn,
      guardian: !isEmpty(state.guardian) ? state.guardian : null,
      mfaPreference: state.mfaPreference,
      username: state.username,
      preferredLanguageCd: state.preferredLanguageCd,
    }
  },
  registrationSSOInfo: (state, getters) =>
    pick(['communicationPreferences', 'smsOptIn'])(getters.registrationInfo),
  resetPasswordIsFetching: (state) => state.resetPasswordIsFetching,
  changePasswordFromResetIsFetching: (state) =>
    state.changePasswordFromResetIsFetching,
  databasePreferredLanguageCd: (state) =>
    get('databasePreferredLanguageCd', state),
  mfaPreference: (state) => {
    return state.mfaPreference
  },
}
